import { NonEmptyArray } from '../types';

export function nonEmptyArrayOr<T, F = null>(arr: T[]): NonEmptyArray<T> | F {
  return arr.length > 0 ? (arr as NonEmptyArray<T>) : (null as F);
}
